import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

const OrganizationContext = createContext(null);

export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (!context) {
    return { orgId: null, orgSlug: null, orgName: null };
  }
  return context;
};

export const OrganizationProvider = ({ children }) => {
  const { user } = useAuth();

  const value = useMemo(() => ({
    orgId: user?.orgId || null,
    orgSlug: user?.orgSlug || null,
    orgName: user?.orgName || null,
  }), [user?.orgId, user?.orgSlug, user?.orgName]);

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  );
};

export default OrganizationContext;
